import Monaco from 'app/common/components/widgets/monaco';
import Switch from 'app/common/components/widgets/switch';
import { fromJS } from 'immutable';
import type { ComponentType } from 'react';
import type { WidgetProps } from '../../../../schema-form/types.js';

export const FORM_NAME = 'mockClaims';

export type MockClaimsFormValues = {
  useMockClaims: boolean;
  mockClaims: string;
};

export const INITIAL_MOCK_CLAIMS_STATE = {
  useMockClaims: false,
  mockClaims: {}
};

export const INITIAL_MOCK_CLAIMS_FORM_STATE = {
  useMockClaims: false,
  mockClaims: '{}'
};

export const formSchema = fromJS({
  type: 'object',
  properties: {
    useMockClaims: {
      title: 'Mock Claims',
      type: 'boolean'
    },
    mockClaims: {
      title: 'Mock Claims JSON',
      type: 'string'
    }
  },
  required: []
});

export const formConfig = fromJS({
  order: ['useMockClaims', 'mockClaims'],
  properties: {
    useMockClaims: {
      widget: 'switch'
    },
    mockClaims: {
      widget: 'monaco',
      options: {
        height: '100%'
      }
    }
  }
});

export const formWidgets: Record<string, ComponentType<WidgetProps>> = {
  switch: Switch,
  monaco: Monaco
};
